import { ElementType, ReactElement, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import LoaderTable from '@loaders/LoaderTable';

import { RootState } from 'src/store/reducers';

import * as actions from '@redux-actions/';

import { deleteUserEyeExam, getUserEyeExams } from '@services/myAppointmentServices';

import { getLabelFallback, isMobile } from '@utils/utils';

import { EyeExamsConfig } from '@utils/pages-utils/EyeExamsUtils';

import { compareAsc, compareDesc } from 'date-fns/esm';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import EyeExamCancelModal from './EyeExamsCancelModal';
import EyeExamDoctorInfoModal from './EyeExamsDoctorInfoModal';
import EyeExamCard from './EyeExamCard';
import clsx from 'clsx';
import { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import SelectIcon from '@images/svg-icons/selectIcon.svg';




const EyeExamsList = (): ReactElement => {
    const config = useSelector((state: RootState) => state.common.config);
    const userEyeExams = useSelector((state: RootState) => state.myAppointment.userEyeExams);
    const getUserEyeExamsRequestStatus = useSelector(
        (state: RootState) => state.myAppointment.getUserEyeExamsRequestStatus
    );
    const deleteEyeExamRequestStatus = useSelector(
        (state: RootState) => state.myAppointment.deleteEyeExamRequestStatus
    );

    const dispatch = useDispatch();
    const clonedEyeExamsConfig = cloneDeep(EyeExamsConfig);

    const [eyeExamsConfig, setEyeExamsConfig] = useState(clonedEyeExamsConfig);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
    const [isOpenDoctorInfoModal, setIsOpenDoctorInfoModal] = useState<boolean>(false);
    const [currentExamId, setCurrentExamId] = useState<number>(null);
    const [storeNumber, setStoreNumber] = useState<string>(null);
    const [currentDoctorId, setCurrentDoctorId] = useState<number>(null);
    const [examToggleSelected, setExamToggleSelected] = useState(false); //upcoming exams selected
    const [sortDirection, setSortDirection] = useState<string>('asc');

    useEffect(() => {
        dispatch(getUserEyeExams(config.mockRequest, config.storeId, config.endPointStatusExams, config.difKeyStatusAppointments, config.authEncoded));
        return () => {
            dispatch(actions.getUserEyeExamsSuccess(null));
        };
    }, []);

    useEffect(() => {
        const now = new Date();
        const twoYearsAgo = new Date();
        twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

        if (!!userEyeExams && userEyeExams.length > 0) {
            userEyeExams
                .filter(exam => compareAsc(new Date(exam.timestamp), twoYearsAgo) === 1)
                .forEach(exam => {
                    if (["CANCEL", "COMPLETE", "NEE", "CONFIRM"].includes(exam.status)) {
                        compareAsc(new Date(exam.timestamp), now) === 1
                            ? clonedEyeExamsConfig.upcoming.eyeExams.push(exam)
                            : clonedEyeExamsConfig.past.eyeExams.push(exam);

                        setEyeExamsConfig(clonedEyeExamsConfig);
                    } else {
                        console.log("appointment not show", exam);
                    }
                });
        }
    }, [userEyeExams]);

    useEffect(() => {
        if (eyeExamsConfig.past?.eyeExams?.length > 0 && eyeExamsConfig.upcoming?.eyeExams?.length === 0) {
            setExamToggleSelected(true); // only past exam
        } else if (eyeExamsConfig.past?.eyeExams?.length === 0 && eyeExamsConfig.upcoming?.eyeExams?.length > 0) {
            setExamToggleSelected(false); // reset or handle other logic if necessary
        }
    }, [eyeExamsConfig]);

    const onDeleteModalSubmit = () => {
        dispatch(deleteUserEyeExam(config.mockRequest, config.storeId, currentExamId, config.endPointStatusExams, config.difKeyStatusAppointments, config.authEncoded));
        ['SUCCESS', 'ERROR'].includes(deleteEyeExamRequestStatus) && setIsOpenDeleteModal(false);
    };

    const openDeleteModal = (schedId: number) => {
        setIsOpenDeleteModal(true);
        setCurrentExamId(schedId);
    };

    const openDoctorInfoModal = (storeNumber: string, providerId: number) => {
        setStoreNumber(storeNumber);
        setCurrentDoctorId(providerId);
        setIsOpenDoctorInfoModal(true);
    };

    const handleSortChange = (event: SelectChangeEvent) => {
        setSortDirection(event.target.value as string);
    };


    const sortedEyeExams = useMemo(() => {
        return (exams: any[]) => {
            return exams.sort((a, b) =>
                sortDirection === 'asc'
                    ? compareAsc(new Date(a.timestamp), new Date(b.timestamp))
                    : compareDesc(new Date(a.timestamp), new Date(b.timestamp))
            );
        };
    }, [eyeExamsConfig, sortDirection]);

    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <div className="eye-exams-list">
            <div
                role="region"
                aria-label="eye exams details title"
                className="eye-exams-details-title primary-title"
            >
                {getLabelFallback('DASHBOARD_MANAGE_EYE_EXAMS_CARD_TITLE')}
            </div>

            {getUserEyeExamsRequestStatus === 'SUCCESS' &&
                (eyeExamsConfig.past?.eyeExams?.length > 0 || eyeExamsConfig.upcoming?.eyeExams?.length > 0) && (
                    <div className="eye-exams-details">

                        <div className='toggle-and-order-wrapper'>
                            {eyeExamsConfig.past?.eyeExams?.length > 0 && eyeExamsConfig.upcoming?.eyeExams?.length > 0 && (
                                <div className="exam-toggle-container" role="navigation" aria-label="exam toggle">
                                    <div className="exam-upcoming-button">
                                        <button
                                            className={clsx(
                                                'exam-button button-size-medium',
                                                examToggleSelected && 'toggle-not-selected',
                                                !examToggleSelected && 'toggle-selected'
                                            )}
                                            onClick={() => setExamToggleSelected(false)}
                                            aria-label="show upcoming exams"
                                        >
                                            {getLabelFallback(
                                                'MYAPPOINTMENTS_EYE_EXAMS_UPCOMING_TOOGLE_LABEL'
                                            )}
                                        </button>
                                    </div>
                                    <div className="exam-past-button">
                                        <button
                                            className={clsx(
                                                'exam-button button-size-medium',
                                                examToggleSelected && 'toggle-selected',
                                                !examToggleSelected && 'toggle-not-selected'
                                            )}
                                            onClick={() => setExamToggleSelected(true)}
                                            aria-label="show past exams"
                                        >
                                            {getLabelFallback(
                                                'MYAPPOINTMENTS_EYE_EXAMS_PAST_TOOGLE_LABEL'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {eyeExamsConfig.past?.eyeExams?.length > 1 && examToggleSelected && (
                                <div className='sortby-wrapper'>
                                    <div className='sortby-title'>Sort by:</div>
                                    {/* <select id="sortDropdown" value={sortDirection} onChange={handleSortChange}>
                                                <option value="asc">{getLabelFallback('MYAPPOINTMENTS_EYE_EXAMS_PAST_ASC_SORT')}</option>
                                                <option value="desc">{getLabelFallback('MYAPPOINTMENTS_EYE_EXAMS_PAST_DESC_SORT')}</option>
                                    </select> */
                                        <FormControl variant="standard" sx={{
                                            m: 1, minWidth: 120, '@media (max-width: 1199.5px)': {
                                                m: '4px 0 0 0',
                                            }
                                        }}>
                                            <Select
                                                id="sortDropdown"
                                                value={sortDirection}
                                                onChange={handleSortChange}
                                                IconComponent={SelectIcon as ElementType}
                                                onOpen={handleOpen}
                                                onClose={handleClose}
                                                open={isOpen}
                                                className={`custom-select ${isOpen ? 'is-open' : ''}`}
                                                renderValue={(selected) => getLabelFallback(`MYAPPOINTMENTS_EYE_EXAMS_PAST_${selected.toUpperCase()}_SORT`)}
                                            >
                                                {sortDirection !== 'asc' && (
                                                    <MenuItem
                                                        value="asc"
                                                        className="custom-menu-item"

                                                    >
                                                        {getLabelFallback('MYAPPOINTMENTS_EYE_EXAMS_PAST_ASC_SORT')}
                                                    </MenuItem>
                                                )}
                                                {sortDirection !== 'desc' && (
                                                    <MenuItem value="desc" className="custom-menu-item"

                                                    >
                                                        {getLabelFallback('MYAPPOINTMENTS_EYE_EXAMS_PAST_DESC_SORT')}
                                                    </MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    }
                                </div>
                            )}
                        </div>

                        {sortedEyeExams(examToggleSelected ? eyeExamsConfig.past.eyeExams : eyeExamsConfig.upcoming.eyeExams).map(eyeExam => (<div className="eye-exams-details-content">

                            <EyeExamCard
                                key={eyeExam.schedId}
                                eyeExam={eyeExam}
                                openDeleteModal={openDeleteModal}
                                openDoctorInfoModal={openDoctorInfoModal}
                                isUpcoming={!examToggleSelected}
                            />


                        </div>))}



                    </div>
                )
            }
            {getUserEyeExamsRequestStatus === 'LOADING' && <LoaderTable />}

            <EyeExamCancelModal
                isOpenDeleteModal={isOpenDeleteModal}
                isSubmitting={deleteEyeExamRequestStatus === 'LOADING'}
                onModalSubmit={onDeleteModalSubmit}
                onCloseModal={() => {
                    setIsOpenDeleteModal(false);
                    setStoreNumber(null);
                }}
            />

            {storeNumber && currentDoctorId && (
                <EyeExamDoctorInfoModal
                    isOpenDoctorInfoModal={isOpenDoctorInfoModal}
                    onCloseModal={() => {
                        setIsOpenDoctorInfoModal(false);
                        setCurrentDoctorId(null);
                    }}
                    storeNumber={storeNumber}
                    doctorId={currentDoctorId}
                />
            )}

            {(eyeExamsConfig.past?.eyeExams?.length > 0 || eyeExamsConfig.upcoming?.eyeExams?.length > 0) && (<hr />)}
        </div >
    );
};
export default EyeExamsList;
